import styled, { css } from "react-emotion";

export const container = css`
  position: relative;
`;

export const card = css`
  background: #58cdce;
  margin: 5px;
  min-height: 150px;
  border-radius: 5px;
  padding: 8px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const title = css`
  color: white;
`;

export const button = css`
  border: 1px solid white;
  padding: 10px;
  border-radius: 30px;
  color: white;
`;

export const StarGroup = styled("div")`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 20px 0 10px 0;
`;

export const underline = css`
  text-decoration: underline;
  margin-top: 10px;
  text-align: left;
  color: white;
  cursor: pointer;
`;

export const finePrintStyle = css`
  position: absolute;
  background: white;
  color: black;
  bottom: 4px;
  width: 15em;
  z-index: 10;
  word-wrap: break-word;
`;
